import { disconnect } from '@puzzlehq/sdk';
import { getNestedStringProperty } from '@puzzlehq/types';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-hot-toast';
import { useArcadeRecords } from './useArcadeRecords';

export const useArcadeCoins = (
  amount = 1,
  showToast: boolean = true,
  disconnectOnError: boolean = false
) => {
  const { parcRecordsUnspent, loading, error } = useArcadeRecords();

  useEffect(() => {
    if (error) {
      console.error(error);
      showToast && toast.error(`Error fetching arcade coins: ${error}`);
      disconnectOnError && void disconnect();
    }
  }, [error]);

  const balance = parcRecordsUnspent
    ? parcRecordsUnspent.reduce(
        (acc, record) =>
          acc +
          Number(
            getNestedStringProperty(record.data, ['amount'])?.replace(
              'u64.private',
              ''
            ) ?? 0
          ) /
            1_000_000,
        0
      )
    : undefined;

  const filteredRecords = parcRecordsUnspent
    ? parcRecordsUnspent.filter(
        (record) =>
          Number(
            getNestedStringProperty(record.data, ['amount'])?.replace(
              'u64.private',
              ''
            ) ?? 0
          ) /
            1_000_000 >=
          amount
      )
    : parcRecordsUnspent;

  const arcadeCoin = useMemo(
    () =>
      filteredRecords?.length
        ? filteredRecords[filteredRecords.length - 1]
        : undefined,
    [JSON.stringify(filteredRecords)]
  );

  return { records: filteredRecords, arcadeCoin, loading, error, balance };
};
